import { RESPONSE_URLS } from "../../services/apiConfig.js";
import { RESPONSE_ERRORS } from "../../common/constants/scheduleModule/responseConstants.js";
import apiClient from "../apiInstance.js";

export const fetchResponseData = async ({startDate, endDate, responseType}) => {
    try {
        const response = await apiClient.post(RESPONSE_URLS.GET_RESPONSE, {
            startDate,
            endDate,
            responseType
        });
        return response.data;
    } catch (error) {
        console.error(RESPONSE_ERRORS.FETCH_RESPONSE_ERROR, error);
        throw error;
    }
};
